module.exports = __webpack_public_path__ + "img/after5.f5a657ff.jpg";